module.exports = __webpack_public_path__ + "static/media/58.d5a4b200.png";